/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load Adroll event listeners
 *
 * https://help.adroll.com/hc/en-us/articles/360040116252-Connect-AdRoll-to-your-site-by-installing-the-AdRoll-Pixel
 *
 * */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", () => {

	if (
		pmwDataLayer?.pixels?.adroll?.advertiser_id
		&& pmwDataLayer?.pixels?.adroll?.pixel_id
		&& !pmwDataLayer?.pixels?.adroll?.loaded) {
		if (pmw.consent.canPixelBeFired("marketing", "Adroll")) pmw.load_adroll_pixel()
	}
})

// view search event
// https://gist.github.com/dennismarlowe/c6826c360d34d9cf5ba7f7011e8a9741#file-product-search
pmw.bus.on("pmw:pixel:search", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "adroll")) return
		if (pmw.canNotFireAdrollEvent()) return

		const adrollData = payload.pixels?.adroll;
		if (!adrollData) return;

		window.adroll.track(adrollData.event_name, adrollData.event_data)
		pmw.console.log("Adroll: productSearch event sent", adrollData.event_data)

	} catch (e) {
		console.error(e)
	}
})

// homeView event
// https://gist.github.com/dennismarlowe/59a5e7c7635d54ca36c4c0dd8d34dd70#file-home-view
pmw.bus.on("pmw:pixel:everywhere-else", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "adroll")) return
		if (pmw.canNotFireAdrollEvent()) return

		const adrollData = payload.pixels?.adroll;
		if (!adrollData) return;

		window.adroll.track(adrollData.event_name)
		pmw.console.log("Adroll: homeView event sent")

	} catch (e) {
		console.error(e)
	}
})

// view product event
// https://gist.github.com/dennismarlowe/6ac4fc4b5d0b228f59683135dcdec51b#file-capturing-product-information
pmw.bus.on("pmw:pixel:view-item", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "adroll")) return
		if (pmw.canNotFireAdrollEvent()) return

		const adrollData = payload.pixels?.adroll;
		if (!adrollData) return;

		window.adroll.track(adrollData.event_name, adrollData.event_data)
		pmw.console.log("Adroll: productView event sent", adrollData.event_data)

	} catch (e) {
		console.error(e)
	}
})

// add-to-cart event
// https://gist.github.com/dennismarlowe/1fede6dfba0d1243072b32aa23413537#file-add-to-cart
pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "adroll")) return
		if (pmw.canNotFireAdrollEvent()) return

		const adrollData = payload.pixels?.adroll;
		if (!adrollData) return;

		window.adroll.track(adrollData.event_name, adrollData.event_data)
		pmw.console.log("Adroll: addToCart event sent", adrollData.event_data)

	} catch (e) {
		console.error(e)
	}
})

// View order received page event
// https://gist.github.com/dennismarlowe/090c96c6629d5ca2056a8394cc060c79#file-purchase
pmw.bus.on("pmw:pixel:purchase", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "adroll")) return
		if (pmw.canNotFireAdrollEvent()) return

		const adrollData = payload.pixels?.adroll;
		if (!adrollData) return;

		window.adroll.track(adrollData.event_name, adrollData.event_data)
		pmw.console.log("Adroll: purchase event sent", adrollData.event_data)

	} catch (e) {
		console.error(e)
	}
})

